<template>
    <el-row
      class='alignLeft'
      v-loading="loading">
      <el-form :inline='true'>
        <el-form-item>
          <el-date-picker
            v-model="request.Date"
            type='daterange'
            range-separator='至'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            format='yyyy-MM-dd'>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="request.EndDate"
            type='daterange'
            range-separator='至'
            start-placeholder='到期开始日期'
            end-placeholder='到期结束日期'
            format='yyyy-MM-dd'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='关键字'>
          <el-input size='small' placeholder='关键字' type='text' v-model='request.SearchKey'>
          </el-input>
        </el-form-item>
        <el-form-item label='起始金额'>
          <el-input size='small' placeholder='起始金额' type='number' v-model="request.Amount1">
          </el-input>
        </el-form-item>
        <el-form-item label='结束金额'>
          <el-input size='small' placeholder='结束金额' type='number' v-model="request.Amount2">
          </el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="request.Payed">
            <el-option
              v-for="el in PayedStatus"
              :label="el.value"
              :key="el.key"
              :value="el.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' type='primary' @click="search">搜索</el-button>
          <el-button size='small' @click="exportData">导出</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data='tableData.data'
        border
        height="80vh"
        :tree-props="{children: 'ChildsList', hasChildren: 'HasChild'}"
        row-key="Apply_Id"
        lazy
        :load="load"
        :row-style="tableRowStyle"
        ref="paymentTable">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          v-for='el in tableData.tableConfig'
          :prop='el.field'
          :label='el.name'
          :key='el.field'
          :width='el.width'>
        </el-table-column>
        <el-table-column
          label="操作"
          width="380"
          fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" v-if="!(scope.row.Sy_Flag < 0 || scope.row.Sy_Flag == 2)" @click="failPayment(scope.row)">作废</el-button>
            <el-button type="warning" size="mini" v-if="!(scope.row.Sy_Flag < 0 || scope.row.Sy_Flag == 2)" @click="closePayment(scope.row)">关闭</el-button>
            <el-button type="primary" size="mini" v-if="CanPaymentCheckIn(scope.row)" @click="OpenPayedCheckIn(scope.row)">付款</el-button>
            <el-button size="mini" @click="PaymentDetail(scope.row)">详情</el-button>
            <el-button type="info" size="mini" @click="ShowPaymentInfo(scope.row)">明细</el-button>
            <el-button type="info" size="mini" v-if="scope.row.IsCsApply === false" @click="PrintApply(scope.row)">打印</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
          @size-change="pageSizeChange"
          @current-change="pageIndexChange"
          :current-page="tableData.pageIndex"
          :page-sizes="[10, 50, 100, 200, 400]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.totalCount">
      </el-pagination>
      <el-dialog
        :visible.sync="paymentCheckInVisible"
        :title="paymentCheckInTitle"
        width="800px"
        custom-class="paymentCheckIn">
        <el-form
          label-width="100px">
          <el-form-item label="开票账户">
            <el-select
              v-model="PayedCheckInRequest.Act_Id">
              <el-option
                v-for="el in InvoiceAccntAndBocRate.InvoiceAccnt"
                :key="el.Act_Id"
                :label="el.Act_Name"
                :value="el.Act_Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="实付金额">
            <el-input type="number" v-model="PayedCheckInRequest.Sub_Amt" @change="ChangeLocalAmt"></el-input>
          </el-form-item>
          <el-form-item label="本币金额">
            <el-input type="number" v-model="PayedCheckInRequest.LocalSub_Amt" :disabled="InvoiceAccntAndBocRate.BocRates === 1"></el-input>
          </el-form-item>
          <el-form-item label="付款日期">
            <el-date-picker
              v-model="PayedCheckInRequest.PayDate"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="备注摘要">
            <el-input
              type="textarea"
              :rows="3"
              v-model="PayedCheckInRequest.Sub_Memof">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="PayedCheckIn">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        :visible.sync="paymentInfoVisible"
        title="付款明细"
        width="90%"
        top="30px"
        border
        custom-class="paymentCheckIn">
        <el-table
          border
          height="360px"
          :data="paymentInfoTable.data"
          :highlight-current-row="true"
          :current-row-key="paymentInfoTable.currentKey"
          row-key="Sub_Id"
          ref="paymentInfoTable"
          @current-change="PaymentInfoCurrentRowChange">
          <el-table-column
            v-for="el in paymentInfoTable.tableConfig"
            :prop='el.field'
            :label='el.name'
            :key='el.field'
            :width='el.width'>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="PayInfoVoid(scope.row)">作废</el-button>
            </template>
          </el-table-column>
        </el-table>
        <hr />
        <el-table
          border
          height="360px"
          :data="paymentInfoChildTable.data"
          v-loading="paymentInfoChildTable.loading">
          <el-table-column
            v-for="el in paymentInfoChildTable.tableConfig"
            :prop='el.field'
            :label='el.name'
            :key='el.field'
            :width='el.width'>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="ShowPayInfoDetailChildDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-row>
</template>

<script>

export default {
  name: 'Payment',
  data () {
    return {
      oasApi: this.$baseUrl,
      formUrl: this.$formUrl,
      paymentDetailUrl: false,
      paymentCheckInVisible: false,
      paymentCheckInTitle: '',
      paymentInfoVisible: false,
      AccCode: '',
      PayedStatus: [
        {key: '', value: '全部'},
        {key: '2', value: '未付清'},
        {key: '1', value: '已付'},
        {key: '4', value: '关闭'},
        {key: '5', value: '作废'}
      ],
      request: {
        Date: ['', ''],
        EndDate: ['', ''],
        Amount1: '',
        Amount2: '',
        SearchKey: '',
        Ref_Srv: 0,
        Ref_Bill: 0,
        Ref_BillCode: '',
        Sub_Type: 'WEB',
        FormCode: '',
        Payed: ''
      },
      // 获取开票公司和本币汇率
      InvoiceAccntAndBocRate: {
        InvoiceAccnt: [],
        BocRates: 0
      },
      PayedCheckInRequest: {
        Act_Id: '',
        Sub_Amt: '',
        LocalSub_Amt: '',
        PayDate: '',
        Sub_Memof: ''
      },
      loading: false,
      tableData: {
        data: [],
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
        tableConfig: [
          { name: '流程ID', field: 'Apply_Id', width: 120 },
          { name: '到期日期', field: 'NeedPay_EDate', width: 100 },
          { name: '日期', field: 'Bill_Date', width: 120 },
          // { name: '工厂户名', field: 'Factory_Account', width: 150 },
          // { name: '工厂地址', field: 'CompanyAddr', width: 150 },
          { name: 'SWIFT_CODE', field: 'SWIFT_CODE', width: 150 },
          { name: '项目名称', field: 'BillType', width: 100 },
          { name: '付款方式', field: 'PayMode', width: 100 },
          { name: '收款银行账户', field: 'PayCode', width: 200 },
          { name: '开票公司', field: 'Act_name', width: 200 },
          { name: '往来单位名称', field: 'Corp_name', width: 200 },
          { name: '供应商全称', field: 'Corp_Name2', width: 200 },
          { name: '供应商中文名称', field: 'Corp_Name_Cn', width: 200 },
          { name: '收款银行', field: 'PayBank', width: 200 },
          { name: '付款金额', field: 'Amt', width: 100 },
          { name: '实付金额', field: 'Payed_Amts', width: 100 },
          { name: '实销金额', field: 'Payed_HxAmts', width: 100 },
          { name: '付款币种', field: 'PayBoc_Id', width: 100 },
          { name: '联络人', field: 'Contact', width: 150 },
          // { name: '邮箱', field: 'Email', width: 120 },
          { name: '结算币种', field: 'Boc_Symbol', width: 100 },
          { name: '申请人', field: 'User_Name', width: 150 },
          { name: '付款日期', field: 'Payed_Date', width: 120 },
          { name: '发票号', field: 'BookNo', width: 120 },
          { name: '发票日期', field: 'NeedPay_BDate', width: 100 },
          { name: '单据状态', field: 'flag', width: 100 },
          { name: '摘要', field: 'Descript', width: 200 }
        ]
      },
      paymentInfoTable: {
        data: [],
        param: {
          Apply_Id: '',
          FormCode: ''
        },
        currentKey: '',
        tableConfig: [
          { name: 'ID', field: 'Sub_Id', width: 80 },
          { name: '付款人', field: 'User_Name', width: 150 },
          { name: '付款日期', field: 'Sub_Date', width: 120 },
          { name: '往来单位', field: 'Corp_Name', width: 220 },
          { name: '开票账号', field: 'Act_Name', width: 200 },
          { name: '付款金额', field: 'Amount', width: 100 },
          { name: '币种', field: 'Boc_Name', width: 100 },
          { name: '备注', field: 'Sub_Memof', width: 200 },
          { name: '收款单号', field: 'Ref_BillCode2', width: 200 },
          { name: '明细标识', field: 'flag', width: 120 }
        ]
      },
      paymentInfoChildTable: {
        data: [],
        loading: false,
        tableConfig: [
          { name: '往来单位', field: 'Corp_Name', width: 150 },
          { name: '开票账户', field: 'Act_name', width: 150 },
          { name: '收款银行账号', field: 'PayCode', width: 150 },
          { name: '单据日期', field: 'Bill_Date', width: 120 },
          { name: '发票号', field: 'BookNo', width: 120 },
          { name: '摘要', field: 'Descript', width: 200 },
          { name: '需付日期', field: 'NeedPay_EDate', width: 100 },
          { name: '实付日期', field: 'Payed_Date', width: 100 },
          { name: '申请金额', field: 'NeedPay_Amts', width: 100 },
          { name: '实付金额', field: 'Payed_Amts', width: 100 },
          { name: '结算币种', field: 'Boc_Symbol', width: 80 },
          { name: '单据编码', field: 'Ref_BillCode', width: 150 }
        ]
      }
    }
  },
  methods: {
    GetPaymentList: function () {
      var _this = this
      _this.loading = true
      var Date1 = ''
      var Date2 = ''
      if (_this.request.Date) {
        Date1 = _this.TransDateToCs(_this.request.Date[0])
        Date2 = _this.TransDateToCs(_this.request.Date[1])
      }
      var param = {
        pageIndex: _this.tableData.pageIndex,
        pageSize: _this.tableData.pageSize,
        Date1: Date1,
        Date2: Date2,
        EndDate1: _this.TransDateToCs(_this.request.EndDate[0]),
        EndDate2: _this.TransDateToCs(_this.request.EndDate[1]),
        SearchKey: _this.request.SearchKey,
        Payed: _this.request.Payed,
        Amount1: _this.request.Amount1 === '' ? 0 : _this.request.Amount1,
        Amount2: _this.request.Amount2 === '' ? 0 : _this.request.Amount2
      }
      _this.$axios.post(_this.oasApi + '/api/UpTop/GetPaymentList', param, {

      }).then(function (response) {
        response.data.List.forEach(element => {
          element.HasChild = element.Childs > 0
          element.ChildsList = []
          element.flag = _this.GetPaymentFlag(element)
          element.Amt = _this.GetPaymentAmt(element)
        })
        _this.tableData.data = response.data.List
        _this.tableData.totalCount = response.data.totalCount
        _this.loading = false
      }).catch(function (response) {
        if (response.response && response.response.data.Message) {
          _this.$message.error(response.response.data.Message)
        } else {
          _this.$message.error(response.message)
        }
        _this.loading = false
      })
    },
    pageIndexChange: function (val) {
      this.tableData.pageIndex = val
      this.GetPaymentList()
      this.$refs.paymentTable.bodyWrapper.scrollTop = 0
    },
    pageSizeChange: function (val) {
      this.tableData.pageSize = val
      this.tableData.pageIndex = 1
      this.GetPaymentList()
      this.$refs.paymentTable.bodyWrapper.scrollTop = 0
    },
    search: function () {
      this.tableData.pageIndex = 1
      this.GetPaymentList()
      this.$refs.paymentTable.bodyWrapper.scrollTop = 0
    },
    // 关闭付款申请单
    closePayment: function (row) {
      var _this = this
      _this.$confirm('确认关闭此申请单', '提示', {

      }).then(() => {
        _this.$axios.get(_this.oasApi + '/api/UpTop/ClosePayment', {
          params: {
            Ref_Srv: row.Ref_Srv,
            Ref_Bill: row.Ref_Bill,
            Ref_BillCode: row.Ref_BillCode,
            FormCode: row.Ref_AppJson1
          }
        }).then((res) => {
          _this.$message('关闭成功')
          _this.GetPaymentList()
        }).catch((res) => {
          if (res.response && res.response.data.Message) {
            _this.$message.error(res.response.data.Message)
          } else {
            _this.$message.error(res.message)
          }
        })
      })
    },
    // 作废付款申请单
    failPayment: function (row) {
      var _this = this
      _this.$confirm('确认作废此申请单', '提示', {

      }).then(() => {
        _this.loading = true
        _this.$axios.get(_this.oasApi + '/api/UpTop/FailPayment', {
          params: {
            Ref_Srv: row.Ref_Srv,
            Ref_Bill: row.Ref_Bill,
            Ref_BillCode: row.Ref_BillCode,
            FormCode: row.Ref_AppJson1
          }
        }).then((res) => {
          _this.$message('作废成功')
          _this.GetPaymentList()
        }).catch((res) => {
          if (res.response && res.response.data.Message) {
            _this.$message.error(res.response.data.Message)
          } else {
            _this.$message.error(res.message)
          }
          _this.loading = false
        })
      })
    },
    // 申请单详情
    PaymentDetail: function (row) {
      var accessToken = JSON.parse(sessionStorage.getItem('accessToken'))
      var jwtHeader = accessToken.access_token
      // var oasToken = accessToken.oasToken
      this.paymentDetailUrl = this.oasApi + '/WorkFlow/ApplyDetailForCS.aspx?applyId=' + row.Apply_Id + '&jwtHeader=' + jwtHeader // + '&token=' + oasToken
      window.open(this.paymentDetailUrl)
    },
    // 转换日期为yyyyMMdd
    TransDateToCs: function (val) {
      if (val) {
        var date = new Date(val)
        return date.getFullYear() + '' + (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) + (date.getDate() >= 10 ? date.getDate() : '0' + date.getDate())
      } else {
        return val
      }
    },
    load: function (tree, treeNode, resolve) {
      var _this = this
      _this.$axios.get(_this.oasApi + '/api/UpTop/GetChildPayment?ZApply_ID=' + tree.Apply_Id, {

      }).then(function (res) {
        res.data.forEach((element) => {
          element.flag = _this.GetPaymentFlag(element)
          element.Amt = _this.GetPaymentAmt(element)
        })
        resolve(res.data)
      }).catch(function (res) {
        if (res.response && res.response.data.Message) {
          _this.$message.error(res.response.data.Message)
        } else {
          _this.$message.error(res.message)
        }
      })
    },
    tableRowStyle: function (obj) {
      var _this = this
      if (obj.row.IsDetailWipe === true && _this.tableData.data.filter((m) => { return m.ZApply_Id === obj.row.Apply_Id && m.ZApply_Id !== m.Apply_Id }).length > 0) {
        return { background: 'rgb(202 241 239)' }
      }
    },
    // 获取付款计划表状态
    GetPaymentFlag: function (element) {
      var flag = ''
      switch (element.Sy_Flag) {
        case 0:
          flag = element.IsPayed === true ? '已付' : '未付'
          break
        case 1:
          flag = element.Hx_BillCode ? element.Hx_BillCode : '已核销'
          break
        case 2:
          flag = '关闭'
          break
      }

      if (element.Sy_Flag < 0) {
        flag = '作废'
      }

      if (element.Sy_Flag !== 1 && element.Hx_BillCode) {
        flag = flag + '(' + element.Hx_BillCode + ')'
      }

      return flag
    },
    // 获取付款计划表金额展示
    GetPaymentAmt: function (element) {
      return element.IsDetailWipe && element.Wipe_Amts ? element.Wipe_Amts + '/' + element.NeedPay_Amts : element.NeedPay_Amts
    },
    // 打开付款窗口
    OpenPayedCheckIn: function (row) {
      var _this = this
      if (row.IsDetailWipe || row.Sy_Flag === 2 || row.Sy_Flag < 0) {
        _this.$message.error('该单不能付款登记')
        return false
      }

      if (row.NeedPay_Amts === row.Payed_Amts) {
        _this.$message.error('该单已经付款')
        return false
      }

      _this.PayedCheckInRequest.Sub_Amt = ''
      _this.PayedCheckInRequest.LocalSub_Amt = ''
      _this.PayedCheckInRequest.Sub_Memof = ''
      _this.InvoiceAccntAndBocRate = {
        InvoiceAccnt: [],
        BocRates: 0
      }
      _this.$axios.get(_this.oasApi + '/api/UpTop/GetPayparamCondition', {
        params: {
          Boc_Id: row.Boc_Id,
          Corp_Id: row.Corp_Id
        }
      }).then(function (res) {
        _this.InvoiceAccntAndBocRate = res.data
        _this.PayedCheckInRequest.Act_Id = row.Act_Id
        _this.PayedCheckInRequest.FormCode = row.Ref_AppJson1
        _this.PayedCheckInRequest.Ref_BillCode = row.Ref_BillCode
        _this.PayedCheckInRequest.Ref_Bill = row.Ref_Bill
        _this.PayedCheckInRequest.Ref_Srv = row.Ref_Srv
        _this.paymentCheckInTitle = '付款单付款登记' + '(' + row.Apply_Id + ')' + '(' + row.Boc_Symbol + ')'
        var nowDate = new Date()
        var payDate = nowDate.getFullYear() + '-' + (nowDate.getMonth() + 1) + '-' + nowDate.getDate()
        _this.PayedCheckInRequest.PayDate = payDate
        _this.paymentCheckInVisible = true
      }).catch(function (res) {
        if (res.response && res.response.data.Message) {
          _this.$message.error(res.response.data.Message)
        } else {
          _this.$message.error(res.message)
        }
      })
    },
    // 是否可以付款登记
    CanPaymentCheckIn: function (row) {
      return !((row.IsDetailWipe || row.Sy_Flag === 2 || row.Sy_Flag < 0) || row.NeedPay_Amts === row.Payed_Amts)
    },
    // 修改本地币种
    ChangeLocalAmt: function () {
      var _this = this
      _this.PayedCheckInRequest.LocalSub_Amt = (_this.InvoiceAccntAndBocRate.BocRates * _this.PayedCheckInRequest.Sub_Amt).toFixed(2)
    },
    // 付款
    PayedCheckIn: function () {
      var _this = this
      if (_this.PayedCheckInRequest.Act_Id === '' || _this.PayedCheckInRequest.Act_Id <= 0) {
        _this.$message.error('请选择开票公司')
        return false
      }

      if (isNaN(_this.PayedCheckInRequest.Sub_Amt)) {
        _this.$message.error('请输入正确的实付金额')
        return false
      }

      if (_this.PayedCheckInRequest.Sub_Amt === 0) {
        _this.$message.error('实付金额不能为0')
        return false
      }

      if (isNaN(_this.PayedCheckInRequest.LocalSub_Amt)) {
        _this.$message.error('请输入正确的本币实付金额')
        return false
      }

      _this.$confirm('确认付款?', '提示', {

      }).then(() => {
        _this.loading = true
        _this.$axios.post(_this.oasApi + '/api/UpTop/PayedCheckIn', _this.PayedCheckInRequest
        ).then(function (res) {
          _this.$message('付款成功')
          _this.paymentCheckInVisible = false
          _this.loading = false
          _this.GetPaymentList()
        }).catch(function (res) {
          if (res.response && res.response.data.Message) {
            _this.$message.error(res.response.data.Message)
          } else {
            _this.$message.error(res.message)
          }
          _this.loading = false
        })
      })
    },
    // 付款明细
    ShowPaymentInfo: function (row) {
      var _this = this
      _this.loading = true
      if (row) {
        _this.paymentInfoTable.param = {
          Apply_Id: row.Apply_Id,
          FormCode: row.Ref_AppJson1
        }
      }
      _this.paymentInfoChildTable.data = []
      _this.$axios.get(_this.oasApi + '/api/UpTop/GetPayInfoDetail', {
        params: {
          ApplyID: _this.paymentInfoTable.param.Apply_Id,
          FormCode: _this.paymentInfoTable.param.FormCode
        }
      }).then((res) => {
        _this.loading = false
        res.data.forEach((element) => {
          var str = ''
          switch (element.Sy_Flag) {
            case 0:
              str = '待核销'
              break
            case 1:
              str = '已核销'
              break
            case 2:
              str = '待确认'
              break
          }
          element.flag = str
        })
        _this.paymentInfoTable.data = res.data
        _this.paymentInfoVisible = true
        if (res.data.length > 0) {
          _this.paymentInfoTable.currentKey = _this.paymentInfoTable.data[0].Sub_Id
          _this.PayInfoDetailChildList(_this.paymentInfoTable.currentKey)
        }
      }).catch((res) => {
        if (res.response && res.response.data.Message) {
          _this.$message.error(res.response.data.Message)
        } else {
          _this.$message.error(res.message)
        }
        _this.loading = false
      })
    },
    // paymentInfo当前行改变
    PaymentInfoCurrentRowChange: function (currentRow, oldCurrentRow) {
      var _this = this
      _this.PayInfoDetailChildList(currentRow.Sub_Id)
    },
    // 费用明细子表
    PayInfoDetailChildList: function (MSuIds) {
      var _this = this
      _this.paymentInfoChildTable.loading = true
      _this.paymentInfoChildTable.data = []
      _this.$axios.get(_this.oasApi + '/api/UpTop/GetPayInfoDetailChildList', {
        params: {
          MSu_Ids: MSuIds
        }
      }).then((res) => {
        _this.paymentInfoChildTable.loading = false
        _this.paymentInfoChildTable.data = res.data
      }).catch((res) => {
        if (res.response && res.response.data.Message) {
          _this.$message.error(res.response.data.Message)
        } else {
          _this.$message.error(res.message)
        }
        _this.paymentInfoChildTable.loading = false
      })
    },
    // 费用明细子表明细
    ShowPayInfoDetailChildDetail: function (row) {
      var accessToken = JSON.parse(sessionStorage.getItem('accessToken'))
      var jwtHeader = accessToken.access_token
      var oasToken = accessToken.oasToken
      this.paymentDetailUrl = this.oasApi + '/WorkFlow/ApplyDetailForCS.aspx?applyId=' + row.Apply_Id + '&jwtHeader=' + jwtHeader + '&token=' + oasToken
      window.open(this.paymentDetailUrl)
    },
    // 作废付款明细
    PayInfoVoid: function (row) {
      var _this = this
      _this.$confirm('确认作废付款明细', '提示', {

      }).then(() => {
        _this.loading = true
        _this.$axios.get(_this.oasApi + '/api/UpTop/PayInfoVoid', {
          params: {
            SubId: row.Sub_Id
          }
        }).then((res) => {
          _this.loading = false
          _this.$message('作废成功')
          _this.paymentInfoTable.data = []
          _this.paymentInfoTable.currentKey = ''
          _this.$nextTick(() => {
            _this.ShowPaymentInfo()
          })
        }).catch((res) => {
          if (res.response && res.response.data.Message) {
            _this.$message.error(res.response.data.Message)
          } else {
            _this.$message.error(res.message)
          }
          _this.loading = false
        })
      })
    },
    // 导出
    exportData: function () {
      var _this = this
      var accessToken = JSON.parse(sessionStorage.getItem('accessToken'))
      var jwtHeader = accessToken.access_token
      var data = {
        aryDbName: [_this.AccCode],
        Date1: _this.TransDateToCs(_this.request.Date[0]),
        Date2: _this.TransDateToCs(_this.request.Date[1]),
        EndDate1: _this.TransDateToCs(_this.request.EndDate[0]),
        EndDate2: _this.TransDateToCs(_this.request.EndDate[1]),
        Amount1: _this.request.Amount1 === '' ? 0 : _this.request.Amount1,
        Amount2: _this.request.Amount2 === '' ? 0 : _this.request.Amount2,
        SearchKey: _this.request.SearchKey,
        Payed: _this.request.Payed,
        Ref_BillType: '',
        AttrType: 1
      }
      window.open(_this.oasApi + '/handler/ExportPaymentlist.ashx?action=payment&searchKey=' + JSON.stringify(data) + '&jwtHeader=' + jwtHeader)
    },
    PrintApply: function (row) {
      var accessToken = JSON.parse(sessionStorage.getItem('accessToken'))
      window.open(this.formUrl + '/Reports/Preview?applyIds=' + row.Apply_Id + '&token=' + accessToken.oasToken)
    }
  },
  created: function () {
    var _this = this
    // 初始化 加减三个月
    var nowDate = new Date().getTime()
    var SixMonth = 6 * 30 * 24 * 60 * 60 * 1000
    var Date1 = new Date(nowDate - SixMonth)
    var Date2 = new Date(nowDate + SixMonth)
    _this.request.Date = [Date1, Date2]

    _this.$axios.get(_this.oasApi + '/api/UpTop/GetAccCode', {

    }).then((res) => {
      _this.AccCode = res.data
    }).catch((res) => {
      if (res.response && res.response.data.Message) {
        _this.$message.error(res.response.data.Message)
      } else {
        _this.$message.error(res.message)
      }
    })
    _this.GetPaymentList()
  }
}
</script>

<style scoped>
  .alignLeft {
    text-align: left;
  }
  .el-button+.el-button {
    margin-left: 0;
  }
</style>
<style>
  .paymentCheckIn {
    width: 900px;
  }
  .paymentCheckIn .el-dialog__header {
    background-color: #F8F8F8;
    font-size: 14px;
    color: #333;
    padding: 10px;
  }
  .paymentCheckIn .el-dialog__headerbtn {
    top: 16px;
  }
  .el-table__header th {
    background-color: #E7E7E7;
    color: gray;
    font-weight: bold;
  }
  .el-table--border td,.el-table--border th {
    border-right: 1px solid #dddddd;;
  }
  .el-table td, .el-table th.is-leaf {
    border-bottom: 1px solid #dddddd;;
  }
</style>



// WEBPACK FOOTER //
// src/components/Payment.vue